import React from 'react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
import { GapDiagram } from './GapDiagram';
const firstJob = ['It captured your thinking.', 'It created credibility.', 'It gave readers a way into your work.'];
const nextJob = ['It cannot tell each reader what applies to them.', 'It cannot help them choose a useful next move.', 'It cannot show you what they cared about.', 'It cannot connect different readers to the right offers.'];

/**
 * Consolidated first-job / next-job argument + Diagram 1 (without/with).
 * Replaces the former gap copy, WhyGap transition, and overlapping explanations.
 */
export function Gap() {
  return <SectionBand tone="paperDark" width="wide" data-id="element-735" data-mp="zkms6koseo37">
      <div className="max-w-3xl" data-id="element-736" data-mp="zlg2twqv9xqm">
        <Reveal data-id="element-737" data-mp="zik6udykxj4t">
          <Eyebrow data-id="element-738" data-mp="lkvi2v1e5ruh">The first job</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-[1.08] text-navy md:text-5xl" data-id="element-739" data-mp="llwy7dx9l4j2">
            Your book did its first job.
          </h2>
          <ul className="mt-8 space-y-5" data-id="element-740" data-mp="qlsyb22ucbtc">
            {firstJob.map(line => <li key={line} className="border-l-2 border-seaglass pl-5 font-serif text-xl leading-snug text-navy md:text-2xl" data-id="element-741" data-mp="3mcht62uo3tpl">
                {line}
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.08} data-id="element-742" data-mp="3ve7kl8ojusnd">
          <div className="mt-16 border-t border-gray-200/80 pt-14" data-id="element-743" data-mp="3vcd88ircg8uw">
            <Eyebrow data-id="element-744" data-mp="3qg5zyjbh6l9s">The next job</Eyebrow>
            <h2 className="mt-4 font-serif text-3xl leading-[1.08] text-navy md:text-5xl" data-id="element-745" data-mp="32q21eqd59bpn">
              But a book cannot do the next job by itself.
            </h2>
            <ul className="mt-8 space-y-4" data-id="element-746" data-mp="2yqbbspzct1mp">
              {nextJob.map(line => <li key={line} className="text-lg leading-relaxed text-navy/72 md:text-xl" data-id="element-747" data-mp="3cgwwmk8dbln8">
                  {line}
                </li>)}
            </ul>
            <p className="mt-10 font-serif text-2xl italic leading-snug text-navy md:text-3xl" data-id="element-748" data-mp="37nbzeuelmvp3">
              A homepage is not a next step.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.12} data-id="element-749" data-mp="2eyn0n210n2gi">
        <div className="mt-14" data-id="element-750" data-mp="ixuqdxbuasih">
          <GapDiagram data-id="element-751" data-mp="iwtgvxah2e2v" />
        </div>
      </Reveal>
    </SectionBand>;
}